import Vue from 'vue'
import App from './App'
import router from './router'
// 引入element-ui
import ElementUI from 'element-ui';
import "element-ui/lib/theme-chalk/index.css";
import axios from 'axios';
import VueAxios from 'vue-axios';
import store from './store/index.js';
import myComponent from './components/index';
import './assets/css/common.scss';
import apiAxios from './api/api';
import * as math from 'mathjs';

Vue.prototype.$math = math;

Vue.use(myComponent)
Vue.use(ElementUI)
// Vue.use(VueAxios,axios);
Vue.use(VueAxios,apiAxios);
Vue.config.productionTip = false

router.beforeEach((to,from,next)=>{
	if(to.meta.requireAuth){
		if(window.sessionStorage.getItem("suser")){
			next()
		}else{
			next({path:'/login'})
		}
	}else{
		next()
	}
})


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')